import axios from 'axios';
import CountryFlag from "@/components/country-intl/country-flag";
import countryList from '@/components/country-intl/country-list.js' // 导入国家列表数据
export default {
  data(){
    return {
      AreaCodeShow:false,
      // AreaCodeList:['86','886','63','84','66','81','82','351','91','63'],
      AreaCodeList:[],
      countryCode:{
        en:'63',
        vi:'84',
        th:'66',
        'zh-CN':'86',
        'zh-TW':'886',
        ja:'81',
        ko:'82',
        pt:'351',
        hi:'91',
        tl:'63',
        ms:'60',//马来
      },
      countryAreaTimer:null
    }
  },
  components:{
    CountryFlag
  },
  computed:{
  },
  watch: {
  },
  created() {
    // this.getAreaCode();
  },

  mounted(){
  },

  methods:{
    getCountrieCode(item){
      if(this.IsSingleWallet&&(this.ruleForm.Currency=='TWD' || this.ruleForm.Currency=='twd')){
        return false;
      }
      this.AreaCodeShow=!this.AreaCodeShow;
      if(item&&item.dialCode){
        this.setAreaCode(item);
      }
    },
    setFlagName(Code){
      let Name=""
      for (let item in countryList) {
        if(countryList[item].dialCode==Code){
          Name = item;
          break;
        }
      }
      return Name
    },
    countryArea(){//获取当前地区代码
      this.countryAreaTimer=setInterval(()=>{

          clearInterval(this.countryAreaTimer);
          let areaCode="zh-TW";
          let defaultCode="";
          let apiUrl=this.baseUrl+"/request/site/info/getareacode";
          axios.post(apiUrl).then(response => {
            let res=response.data;
            if(res.success){
              let AreaCodeList = res.info;//站点支持的电话区号
              let dfCode="";
              if(AreaCodeList&&AreaCodeList.length>0){
                this.AreaCodeList= AreaCodeList;
                AreaCodeList.forEach(Code=>{
                  if(areaCode&&Code==areaCode){
                    dfCode=areaCode;
                  }
                })
                if(dfCode){
                  defaultCode=dfCode;
                } else{
                  defaultCode=AreaCodeList[0];
                }
                this.setCountryCode(defaultCode);
              } else{
                this.setCountryCode(areaCode);
              }
            }
          })

      },100)

    },

  },

}



// WEBPACK FOOTER //
// ./src/mixins/country-mixins.js